// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".coupon-empty-wrapper[data-v-0a277ea2]{align-items:center;background:#fff;border-radius:.12rem;box-sizing:border-box;display:flex;flex-direction:column;justify-content:center;padding:.46rem .16rem}.coupon-empty-wrapper .icon-empty[data-v-0a277ea2]{height:.76rem;width:.76rem}.coupon-empty-wrapper .empty-text[data-v-0a277ea2]{color:#000;font-family:\"PP Right Grotesk\";font-size:.22rem;font-weight:900;line-height:.28rem;margin-top:.04rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
